import { createReducer, on } from '@ngrx/store';
import { CatalogApiState } from '../../models/states/catalog-api.interfaces';
import * as fromCatalogApiActions from '../actions/catalog-api.actions';

export const CatalogApiStateKey = 'catalogApi';

const initialState: CatalogApiState = {
  isReady: false,
  isError: false,
  catalogApiData: null
};

export const catalogApiReducer = createReducer(
  initialState,
  on(
    fromCatalogApiActions.LoadCatalogApiSuccess,
    (state, { catalogApiData }) => ({
      ...state,
      isReady: true,
      isError: false,
      catalogApiData
    })
  ),
  on(fromCatalogApiActions.LoadCatalogApiFailure, (state) => ({
    ...state,
    isReady: false,
    isError: true
  }))
);
